export default __webpack_public_path__ + "static/media/pepper_kissing.aab8b0c6.png";